import React from "react";
import { Page } from "app";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { SubmissionError } from "redux-form";
import { Form, FormError, SubmitButton } from "app/forms";
import * as fields from "app/auth/fields";
import { signUp } from "app/auth/actions";
import { SIGN_UP } from "app/auth/constants";
import Helmet from "react-helmet";
import { Classes, Callout, Intent } from "@blueprintjs/core";
import { compose } from "recompose";
import { injectIntl } from "react-intl";
import { PrivacyNotice } from "../privacy";
import styled from "styled-components";

const PrivacyBox = styled(Callout)`
  max-height: 600px;
  overflow: scroll;
`;

let SignUpForm = props => {
  const { handleSubmit, submitting, valid, error, intl } = props;
  const className = Classes.LARGE;
  return (
    <Form className="pt-card pt-elevation-1" onSubmit={handleSubmit}>
      <fields.ScreenName props={{ className }} />
      <fields.FullName props={{ className }} />
      <fields.Email props={{ className }} />
      <fields.Password props={{ className, submitting }} />
      <FormError error={error} submitting={submitting} />
      <PrivacyBox>
        <PrivacyNotice />
      </PrivacyBox>
      <fields.AcceptPrivacyNotice />
      <SubmitButton
        valid={valid}
        submitting={submitting}
        text={intl.formatMessage({
          id: "app.signup",
          defaultMessage: "Sign up"
        })}
        className={Classes.LARGE}
      />
    </Form>
  );
};

SignUpForm = injectIntl(reduxForm({ form: "signupForm" })(SignUpForm));

class SignUp extends React.Component {
  state = { done: false };

  handleSubmit = values => {
    return this.props.signUp(values).catch(error => {
      if (error && error.type === SIGN_UP.ERROR) {
        throw new SubmissionError({ _error: error });
      }
      throw error;
    });
  };

  done = () => this.setState({ done: true });

  render() {
    const {
      handleSubmit,
      state: { done },
      props: { intl }
    } = this;
    const title = intl.formatMessage({
      id: "app.signup",
      defaultMessage: "Sign up"
    });
    return (
      <Page className="pt-ui-text-large pt-running-text">
        <Helmet title={title} />
        <h1>{title}</h1>
        {done ? (
          <Callout iconName="envelope" intent={Intent.PRIMARY}>
            <div className="pt-ui-text-large">
              Thank you for signing up! Please check your email to activate your
              account.
            </div>
          </Callout>
        ) : (
          <SignUpForm onSubmit={handleSubmit} onSubmitSuccess={this.done} />
        )}
      </Page>
    );
  }
}

export default compose(
  connect(
    null,
    dispatch => ({
      signUp: values => dispatch(signUp(values))
    })
  ),
  injectIntl
)(SignUp);



// WEBPACK FOOTER //
// ./src/app/auth/SignUp.js